const BASE_URL = "/master-data/vat-posting-group";

export default [
   {
     path: `${BASE_URL}/vat-product-posting-group`,
     name: "VATProductPostingGroupIndex",
     component: () => import("@/pages/masterData/vatProductPostingGroup/Index.vue"),
   },
  {
    path: `${BASE_URL}/vat-business-posting-group`,
    name: "VATBusinessPostingGroupIndex",
    component: () => import("@/pages/masterData/vatBusinessPostingGroup/Index.vue"),
  },
  {
    path: `${BASE_URL}/vat-posting-setup`,
    name: "VATPostingSetupIndex",
    component: () => import("@/pages/masterData/vatPostingSetup/Index.vue"),
  },
];